import React from 'react';

import useFilters from '../../hooks/useFilters';
import useCategories from '../../hooks/useCategories';

import Loading from '../Loading';

import { Error } from '../../views';

import { StyledFilters } from './Filters.styled';

const Filters = ({ filters }) => {
  const { setSorting, setPagination, setTags, tags } = useFilters();
  const { loading, error, data } = useCategories();

  const generateOptionList = (type) => {
    return filters
      ?.filter((el) => el.type === type)
      .map((e) => {
        return (
          <option
            key={e.value + e.text}
            className={'filters__option'}
            value={e.value}
          >
            {e.text}
          </option>
        );
      });
  };

  return (
    <StyledFilters className="filters">
      <label htmlFor="sort">Sort</label>
      <select
        className={'filters__select'}
        onChange={(ev) => {
          setSorting(ev.target.value);
        }}
        id="sort"
      >
        {generateOptionList('sorting')}
      </select>
      <label htmlFor="pagination">Pagination</label>
      <select
        className={'filters__select'}
        onChange={(ev) => {
          setPagination(ev.target.value);
        }}
        id="pagination"
      >
        {generateOptionList('pagination')}
      </select>
      {loading ? (
        <Loading />
      ) : error ? (
        <Error error={error} />
      ) : (
        <div className="filters__inputs-container">
          {data?.map((el) => {
            return (
              <label key={el.data.name} className="filters__label">
                <input
                  type="checkbox"
                  className="filters__checkbox"
                  checked={tags.includes(el.data.name)}
                  onChange={() => {
                    if (tags.includes(el.data.name)) {
                      setTags(tags.filter((t) => t !== el.data.name));
                    } else {
                      setTags([...tags, el.data.name]);
                    }
                  }}
                />
                {el.data.name}
              </label>
            );
          })}
        </div>
      )}
    </StyledFilters>
  );
};

export default Filters;

